<template>
  <v-row no-gutters v-if="list.length === 0" class="mb-2">
    <v-col class="color-card-close d-flex align-center">
      <v-row no-gutters class="w-100 pa-2">
        <v-col
          cols="12"
          sm="1"
          class="d-flex justify-center align-center mb-2 mb-sm-0"
        >
          <v-icon size="32" color="primary">{{ icon }}</v-icon>
        </v-col>
        <v-col
          cols="12"
          sm="9"
          class="mb-2 mb-sm-0 d-flex align-center justify-sm-start justify-center text-center text-sm-start"
        >
          <small class="font-weight-bold d-flex" v-html="subtitle" />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          class="d-flex justify-center align-center justify-sm-end"
        >
          <v-btn
            class="add-button rounded-pill"
            outlined
            :color="$config.dados.secondary"
            dark
            @click="handleClick"
          >
            {{ $t("new-event.buttons.add") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row no-gutters v-else class="mb-2">
    <v-col cols="12" class="color-card-open pa-4">
      <v-col class="d-flex align-center">
        <v-icon size="32" class="mr-3" color="primary">{{ icon }}</v-icon>
        <h3>{{ title }}</h3>
      </v-col>
      <v-form
        ref="formItems"
        v-if="editing"
        v-model="formValid"
        lazy-validation
      >
        <v-col>
          <draggable
            v-if="list && list.length > 0"
            :list="allTickets ?? list"
            :disabled="!enabled || isComponentFocused"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              class="list-group-item"
              v-for="item in allTickets ?? list"
              :key="item.idproduto_variacao"
            >
              <v-row
                v-if="list.includes(item)"
                no-gutters
                class="mb-4 d-flex align-center"
              >
                <v-icon color="primary" style="cursor: grab"
                  >mdi-swap-vertical</v-icon
                >
                <template v-for="field in fields">
                  <v-col
                    v-if="!field.exist"
                    :key="field.idproduto_variacao"
                    cols="12"
                    :md="field.cols ? field.cols : ''"
                    :style="{ minWidth: field.minWidth || '140px' }"
                    class="ml-2 mb-2 d-flex justify-center"
                  >
                    <component
                      :is="getFieldComponent(field)"
                      v-model="item[field.value]"
                      :label="field.text"
                      :key="field.idproduto_variacao + field.text"
                      :type="field.type"
                      :options="field.type === 'money' ? optionsCurrency : null"
                      :name="field.value"
                      :disabled="
                        isFieldDisabled(item.disabled, field.value, item) ||
                        (item.batch > 0 && field.value === 'ticketDate')
                      "
                      :productVariationId="item.idproduto_variacao"
                      :rules="
                        field.hasRules &&
                        !(
                          field.value === 'price' &&
                          (item.disabled === 'price' ||
                            item.disabled?.includes('price') ||
                            item.isReservation ||
                            item.isGratuity ||
                            item.isCourtesy)
                        )
                          ? field.type === 'number'
                            ? [rules.nonNegativeNumber]
                            : [rules.totalRequired]
                          : []
                      "
                      :edit="
                        field.type !== 'image'
                          ? String(item[field.value])
                          : item[field.value]
                      "
                      :items="
                        field.value === 'batch' &&
                        (item.disabled?.includes('batch') ||
                          item?.disabled === 'batch')
                          ? field.itemsSecondary
                          : field.items || []
                      "
                      item-value="value"
                      item-text="text"
                      :maxlength="field.maxlength"
                      hide-details
                      hide-spin-buttons
                      @update:updateImage="updateModelWhenImage($event, item)"
                      @focus="onFocus($event, field.selectContent)"
                      selectContent
                      @blur="onBlur"
                      @wheel.prevent
                    />
                  </v-col>
                </template>
                <div
                  class="ml-1 mb-2 d-flex align-center"
                  v-for="action in actions"
                  :key="action.text"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="primary white--text"
                        v-bind="attrs"
                        v-on="on"
                        width="32"
                        height="32"
                        @click="action.action(item)"
                      >
                        <v-icon size="18">{{ action.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ action.text }}</span>
                  </v-tooltip>
                </div>
              </v-row>
            </div>
          </draggable>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                class="rounded-pill primary ml-1 d-flex justify-space-between align-center"
                width="22"
                height="22"
                outlined
                :color="$config.dados.secondary"
                dark
                fab
                v-if="newAction?.length === 1"
                @click="newAction[0].action()"
              >
                <v-icon size="18" color="white" class="mr-1 pr-1"
                  >mdi-plus</v-icon
                >
                <span>{{ newAction[0].text }}</span>
              </v-btn>
              <v-menu offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-pill primary ml-1 d-flex justify-space-between align-center"
                    width="22"
                    height="22"
                    outlined
                    :color="$config.dados.secondary"
                    dark
                    fab
                  >
                    <v-icon size="18" color="white" class="mr-1 pr-1"
                      >mdi-plus</v-icon
                    >
                    <span>{{
                      newActionText ? newActionText : "Novo item"
                    }}</span>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    class="actions-button-add"
                    v-for="(item, index) in newAction"
                    :key="index"
                    @click="item.action"
                  >
                    <v-list-item-title>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end">
              <v-btn
                :loading="getLoadingEvent"
                @click="handleSave"
                class="rounded-pill primary ml-1"
                >{{ $t("new-event.buttons.save") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-form>
      <v-col v-else>
        <v-row>
          <v-col cols="12" md="10">
            <table class="no-style-table custom-table">
              <thead>
                <tr>
                  <template v-for="field in fields">
                    <th
                      v-if="!field.exist"
                      :key="field.idproduto_variacao"
                      class="text-left"
                      style="background-color: transparent"
                    >
                      {{ field.text }}
                    </th>
                  </template>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <template v-for="field in fields">
                    <td
                      v-if="!field.exist"
                      :key="field.idproduto_variacao"
                      class="table-cell"
                      style="background-color: transparent"
                    >
                      <component
                        v-if="isComponent(field.value)"
                        :is="getComponent(field.value)"
                        :edit="item[field.value]"
                        :productVariationId="item.idproduto_variacao"
                        @update:updateImage="updateModelWhenImage($event, item)"
                        class="mb-4"
                      />
                      <p v-else class="mb-1">
                        {{ getFieldDisplayValue(field.value, item) }}
                      </p>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </v-col>

          <v-col cols="12" md="2" class="d-flex justify-end">
            <v-btn
              @click="() => (this.editing = !this.editing)"
              class="ml-sm-4 mb-4 rounded-pill bg-custom-grey"
              outlined
              color="primary"
              dark
              ><v-icon class="mr-1">mdi-clipboard-edit</v-icon>
              {{ $t("new-event.buttons.edit") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import draggable from "vuedraggable";
import BaseTextField from "../forms/BaseTextField.vue";
import BaseMoneyField from "../forms/BaseMoneyField.vue";
import DateTimePicker from "../forms/DateTimePicker.vue";
import BaseImageInput from "../forms/BaseImageInput.vue";
import BaseSelect from "../forms/BaseSelect.vue";
import BaseAutocomplete from "../forms/BaseAutocomplete.vue";
import dayjs from "dayjs";
import formRules from "@/mixins/formRules";
import { getTranslatedText, optionsCurrency } from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "ItemsToSale",
  mixins: [formRules],
  components: {
    draggable,
    BaseTextField,
  },
  props: {
    icon: String,
    title: String,
    subtitle: String,
    isOpen: Boolean,
    fields: Array,
    list: Array,
    allTickets: Array,
    newAction: Array || Object,
    newActionText: String,
    actions: Array,
    addBtn: Function,
    saveBtn: Function,
  },
  data() {
    return {
      isComponentFocused: false,
      isOpenData: this.isOpen,
      enabled: true,
      dragging: false,
      editing: false,
      formValid: false,
      optionsCurrency,
    };
  },
  computed: {
    ...mapGetters([
      "getEventSectorData",
      "getLoadingEvent",
      "getAllDatesOfTickets",
    ]),
    datesWithoutTime() {
      return this.getAllDatesOfTickets.map(date =>
        dayjs(date).format("YYYY-MM-DD")
      );
    },
    status() {
      return [
        {
          text: this.$t("new-event.settings.status.active"),
          value: "ATIVO",
        },
        {
          text: this.$t("new-event.settings.status.inactive"),
          value: "INATIVO",
        },
        {
          text: this.$t("new-event.settings.status.sold-out"),
          value: "ESGOTADO",
        },
      ];
    },
  },
  methods: {
    onFocus(event, selectContent) {
      this.isComponentFocused = true;
      if (selectContent) {
        event.target.select();
      }
    },
    onBlur() {
      this.isComponentFocused = false;
    },
    isComponent(fieldValue) {
      return fieldValue === "images";
    },
    getComponent(fieldValue) {
      switch (fieldValue) {
        case "images":
          return BaseImageInput;
        default:
          return null;
      }
    },
    getFieldDisplayValue(fieldValue, item) {
      switch (fieldValue) {
        case "batch":
          return item.batch === 0
            ? this.$t("new-event.ticket-management.tickets.no-batch")
            : item.batch;

        case "sector":
          return getTranslatedText(
            this.getEventSectorData?.sectors?.find(sector => {
              return sector?.idsetor === item?.sector;
            })?.descricao
          );
        case "price": {
          const price = Number(item.price);
          return `R$ ${price.toFixed(2).replace(".", ",")}`;
        }
        case "salesPeriodStart":
          return dayjs(item.salesPeriodStart).format("DD/MM/YYYY HH:mm");
        case "salesPeriodEnd":
          return dayjs(item.salesPeriodEnd).format("DD/MM/YYYY HH:mm");
        case "ticketDate":
          return dayjs(item.ticketDate).format("DD/MM/YYYY HH:mm");
        case "status":
          return this.status.find(status => status.value === item.status).text;
        case "name":
          return item.name ? item.name : this.$t("no-name");
        default:
          return item[fieldValue];
      }
    },
    getFieldComponent(field) {
      switch (field.type) {
        case "text":
          return BaseTextField;
        case "number":
          return BaseTextField;
        case "money":
          return BaseMoneyField;
        case "date":
          return DateTimePicker;
        case "image":
          return BaseImageInput;
        case "select":
          return BaseSelect;
        case "autocomplete":
          return BaseAutocomplete;
        default:
          return BaseTextField;
      }
    },
    handleClick() {
      if (this.addBtn) {
        this.addBtn();
      }
      this.isOpenData = true;
      this.editing = true;
    },
    isFieldDisabled(disabled, fieldValue, item) {
      if (
        (item.isReservation || item.isGratuity || item.isCourtesy) &&
        fieldValue === "price"
      ) {
        return true;
      }
      if (Array.isArray(disabled)) {
        return disabled.includes(fieldValue);
      } else {
        return disabled === fieldValue;
      }
    },
    updateModelWhenImage(image, itemList) {
      if (image) {
        itemList.images = image;
      }
    },
    async handleSave() {
      if (this.$refs.formItems.validate()) {
        await this.saveBtn();
        this.editing = !this.editing;
      }
    },
  },
  mounted() {
    if (this.$route.path.includes("cadastrar")) {
      this.editing = true;
    }
  },
};
</script>

<style scoped>
thead > tr > th:last-child {
  position: relative !important;
}

tbody > tr > td:last-child {
  position: relative !important;
}

.dynamic-width {
  min-width: 140px;
}

.color-card-close {
  border: 3px dashed #ccc;
  border-radius: 8px;
}

.v-card--link:before {
  border-radius: 10px;
}

.color-card-open {
  background-color: #f7f7fa;
  border-radius: 8px;
}

.add-button {
  background-color: #e9e8ed;
  border: 2px solid;
}

.actions-button-add {
  cursor: pointer;
}

.actions-button-add:hover {
  background-color: #e9e8ed;
}

.no-style-table {
  border-collapse: collapse;
  width: 100%;
}

.no-style-table th,
.no-style-table td {
  border: none;
}

.table-header,
.table-cell {
  padding: 8px;
  min-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-style-table th {
  font-weight: bold;
}

@media (max-width: 600px) {
  .no-style-table {
    display: block;
    overflow-x: auto;
  }

  .table-header,
  .table-cell {
    white-space: normal;
  }
}
</style>
